module.exports = __webpack_public_path__ + "img/entertainment-accent-decor.e884393.jpg";